import { createContext, useContext, useEffect, useMemo, useState } from "react";

import {
    loadMissionOverviewRangeSettings,
    saveMissionOverviewRangeSettings,
} from "lib/fleetMissionStorage/missionOverviewRange";
import type { MissionOverviewRangeSettings } from "lib/fleetMissionStorage/missionOverviewRange";

type MissionOverviewRangeContextValue = {
    rangeSettings: MissionOverviewRangeSettings;
    setRangeSettings: (value: MissionOverviewRangeSettings) => void;
};

const MissionOverviewRangeContext = createContext<MissionOverviewRangeContextValue | null>(null);

export const MissionOverviewRangeProvider = ({ children }: React.PropsWithChildren) => {
    const [rangeSettings, setRangeSettings] = useState(loadMissionOverviewRangeSettings);

    useEffect(() => {
        saveMissionOverviewRangeSettings(rangeSettings);
    }, [rangeSettings]);

    const value = useMemo(() => ({ rangeSettings, setRangeSettings }), [rangeSettings]);

    return (
        <MissionOverviewRangeContext.Provider value={value}>
            {children}
        </MissionOverviewRangeContext.Provider>
    );
};

export const useMissionOverviewRange = (): MissionOverviewRangeContextValue => {
    const context = useContext(MissionOverviewRangeContext);
    if (!context) {
        throw new Error("useMissionOverviewRange must be used inside MissionOverviewRangeProvider");
    }
    return context;
};
